// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@fortawesome/fontawesome-pro/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import "mdbvue/lib/mdbvue.css";
import Vue from 'vue';
import App from './App';
import store from './store';
import router from './router';
import Notify from "./components/common/Notify";
import Vue2TouchEvents from 'vue2-touch-events';
import VueYoutube from 'vue-youtube';
import Meta from 'vue-meta';
import VueI18n from "vue-i18n";
import messages from './lang';

let SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing);
Vue.config.productionTip = false;
Vue.use(Notify);
Vue.use(VueYoutube)
Vue.use(Vue2TouchEvents);
Vue.use(Meta);
Vue.use((VueI18n))

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  if (value == 'rsvp') return 'RSVP'
  let ret = ""
  let parts = value.split(" ")
  for (let i=0; i<parts.length; parts++) {
    if (i>0) ret += " "
    ret += parts[i].charAt(0).toUpperCase() + parts[i].slice(1)
  }
  return ret
})

Vue.mixin({
    methods: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        if (value == 'rsvp') return 'RSVP'
        let ret = ""
        let parts = value.split(" ")
        for (let i=0; i<parts.length; i++) {
          if (i>0) ret += " "
          ret += parts[i].charAt(0).toUpperCase() + parts[i].slice(1)
        }
        return ret
      }
    }
})

export const i18n = new VueI18n({
                                  locale: 'en', // set locale
                                  fallbackLocale: 'en',
                                  messages // set locale messages
});

new Vue({
          el: '#app',
          router,
          store,
          i18n,
          components: {App},
          template: '<App/>'
});

